import "./sass/style.scss";

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

import moment from 'moment';

import router from './router'

import { VueReCaptcha } from 'vue-recaptcha-v3';

const pinia = createPinia()
createApp(App)
    .use(router)
    .use(moment)
    .use(pinia)
    .use(VueReCaptcha, { siteKey: '6Ld1lGwpAAAAAH-JzzkAXSlNv1VCVV6ZmWTbN0HC' })
    .mount('#app')
